import type { Content } from '../../card-types.ts';

// For forming the typename correctly for content types to enable optimistic updates
const capitalizedContentTypes: Record<Content, string> = {
	page: 'Page',
	blogpost: 'BlogPost',
	database: 'Database',
	whiteboard: 'Whiteboard',
	slide: 'Slide',
	embed: 'Embed',
	folder: 'Folder',
};

export const getCapitalizedContentType = (type: Content): string => capitalizedContentTypes[type];
